module.exports = __webpack_public_path__ + "img/nodejs-stencil.6b5791c4.svg";